import { render } from "./ClockScreen.vue?vue&type=template&id=328e5425&bindings={\"message\":\"data\",\"date\":\"data\",\"year\":\"options\",\"month\":\"options\",\"day\":\"options\",\"hours\":\"options\",\"minutes\":\"options\",\"seconds\":\"options\",\"dateTimePadding\":\"options\",\"setDate\":\"options\"}"
import script from "./ClockScreen.vue?vue&type=script&lang=js"
export * from "./ClockScreen.vue?vue&type=script&lang=js"

import "./ClockScreen.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script